import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "order-buy-sell-panel" }
const _hoisted_2 = { class: "order-buy-sell-panel__container" }
const _hoisted_3 = { class: "order-buy-sell-panel__panel" }
const _hoisted_4 = {
  key: 0,
  class: "order-buy-sell-panel__active-account"
}
const _hoisted_5 = { class: "order-buy-sell-panel__account-name" }

import { computed, inject, ref } from 'vue';

import { accountService } from '@exchange/libs/account/service/src';
import { authService } from '@exchange/libs/auth/service/src';
import { subaccountsService } from '@exchange/libs/trading-accounts/service/src';
import { currencyService } from '@exchange/libs/utils/currency/src';

import OrderContainer from './OrderContainer.vue';
import OrderFormSideSwitcher from './OrderFormSideSwitcher.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderBuySellPanel',
  props: {
  marketId: { type: String, required: true },
},
  setup(__props) {



const balanceMasked = inject('balanceMasked', ref(false));

const { accountId } = accountService;
const { defaultFiatCurrency, currencies, fiatPrecision } = currencyService;
const { list: accounts } = subaccountsService;

const panel = {
  value: ref(false),
  open: () => {
    panel.value.value = true;
  },
};

const userHasBeenAuthenticated = computed(() => authService.hasBeenAuthenticated);
const activeAccount = computed(() => accounts.value.find((account) => account.accountId === accountId.value));

const onActiveSideChange = () => {
  panel.open();
};

return (_ctx: any,_cache: any) => {
  const _component_ot_balance = _resolveComponent("ot-balance")!
  const _component_ot_panel = _resolveComponent("ot-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(OrderFormSideSwitcher, {
        class: "order-buy-sell-panel__side-switcher",
        "on-active-side-change": onActiveSideChange
      }),
      _createVNode(_component_ot_panel, {
        open: panel.value.value,
        "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((panel.value.value) = $event)),
        "open-expended": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (userHasBeenAuthenticated.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(activeAccount.value && activeAccount.value.name) + ":", 1),
                  _createVNode(_component_ot_balance, {
                    class: "order-buy-sell-panel__account-balance",
                    value: activeAccount.value && activeAccount.value.getBalanceTotal(_unref(currencies)).all,
                    precision: _unref(fiatPrecision),
                    symbol: _unref(defaultFiatCurrency),
                    masked: _unref(balanceMasked),
                    "light-symbol": true
                  }, null, 8, ["value", "precision", "symbol", "masked"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(OrderContainer, {
              "market-id": __props.marketId,
              "transparent-background": true
            }, null, 8, ["market-id"])
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ])
  ]))
}
}

})